import * as React from 'react';
import { NoSsr } from '@cian/react-utils';
import { Button, Image, UIHeading2, UIText1 } from '@cian/ui-kit';
import { Base64 } from 'js-base64';
import * as styles from './EmptyResultTitle.css';
import image from './assets/image.png';

/**
 * Заголовок: "Нет подходящих ЖК"
 * Сделано через base64, чтобы не было в индексе
 * @see https://jira.cian.tech/browse/OM-930
 **/
const BASE_64_TITLE = '0J3QtdGCwqDQv9C+0LTRhdC+0LTRj9GJ0LjRhSDQltCa';

interface IEmptyResultTitleProps {
  onClick: () => void;
}

export const EmptyResultTitle = ({ onClick }: IEmptyResultTitleProps) => {
  return (
    <noindex>
      <NoSsr defer fallback={<div className={styles['fallback']} />}>
        <div className={styles['container']} data-testid="EmptySearchResult">
          <Image src={image} width={150} height={150} preloader={false} loading="lazy" />
          <div className={styles['content']}>
            <UIHeading2>{Base64.decode(BASE_64_TITLE)}</UIHeading2>
            <UIText1>Попробуйте поменять фильтры или посмотрите похожие ЖК</UIText1>
            <div className={styles['button']}>
              <Button size="M" onClick={onClick} data-testid="reset-filters-button">
                Сбросить фильтры
              </Button>
            </div>
          </div>
        </div>
      </NoSsr>
    </noindex>
  );
};
